import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "8",
      cy: "8",
      r: "7.5",
      stroke: "#6B7470",
      "stroke-dasharray": "2 2"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "m7.612 10.469 4.313-4.314c.1-.1.1-.26 0-.36l-.72-.72c-.1-.1-.26-.1-.36 0L6.982 8.937 5.155 7.112c-.1-.1-.26-.1-.36 0l-.72.72c-.1.1-.1.26 0 .36l2.276 2.277a.889.889 0 0 0 1.26 0Z"
    }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }